import { styled } from '@material-ui/core/styles';
import { 
  TableCell, 
  TableRow, 
  Container,
  Typography,
  Paper
} from '@material-ui/core';

export const PageContainer = styled(Container)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh',
}));

export const TitleContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(4),
  textAlign: 'center',
}));

export const ContainerButtonsTop = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  gap: theme.spacing(2),
  flexWrap: 'wrap',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const DivSearch = styled('div')(({ theme }) => ({
  flexGrow: 1,
  maxWidth: 500,
  display: 'flex',
  gap: theme.spacing(1),
  [theme.breakpoints.down('xs')]: {
    width: '100%',
    maxWidth: 'none',
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  '&.MuiTableCell-head': {
    fontSize: '1rem',
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
  '&.MuiTableRow-root': {
    '&.Mui-selected': {
      backgroundColor: theme.palette.action.selected,
    },
  },
}));

export const ActionButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: theme.spacing(1),
}));

export const StatusChip = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: '16px',
  padding: '4px 12px',
  fontSize: '0.75rem',
  fontWeight: 500,
  backgroundColor: theme.palette.grey[200],
  color: theme.palette.text.primary,
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 2,
  overflow: 'hidden',
  boxShadow: theme.shadows[3],
  marginBottom: theme.spacing(3),
}));

export const EmptyStateContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  textAlign: 'center',
}));

export const PaginationContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(2),
}));

export const DialogTitleStyled = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  padding: theme.spacing(3),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const DialogContentStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
}));

export const DialogActionsStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(2),
}));